export const speechBubble = 'flex items-center justify-start absolute w-52 text-left left-[20px] -top-[70px] text-black text-xs'
